module.exports = __webpack_public_path__ + "img/viggo_royal.13d34208.jpg";